import HttpClienteToken from '../../services/HttpClientToken';

import { TipoAsentamientoProps } from '../../interfaces/catalogos/TipoAsentamientoInterface';

export const ObtenerTiposAsentamientos = () => {

    return new Promise<TipoAsentamientoProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/TipoAsentamiento/ObtenerTipoAsentamientos', token)
            .then( ({ data } : { data : TipoAsentamientoProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const TipoAsentamiento = () => {

    return new Promise<TipoAsentamientoProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/TipoAsentamiento/', token)
            .then( ({ data } : { data : TipoAsentamientoProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ActualizarTipoAsentamiento = ( params: TipoAsentamientoProps ) => {

    return new Promise<TipoAsentamientoProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/TipoAsentamiento/Actualizar', params, token)
            .then( ({ data } : { data : TipoAsentamientoProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idTipoAsentamiento: 0,
                    clave: '',     
                    descripcion: '',
                    activo: false,      
                });
            });
        }

    });

}

export const AgregarTipoAsentamiento = ( params: TipoAsentamientoProps ) => {

    return new Promise<TipoAsentamientoProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/TipoAsentamiento/Agregar', params, token)
            .then( ({ data } : { data : TipoAsentamientoProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idTipoAsentamiento: 0,
                    clave: '',     
                    descripcion: '',
                    activo: false,         
                });
            });
        }

    });

}